import './style/main.scss'
import React from 'react'
import ReactDOM from 'react-dom';

import App from './component/app'
import device from 'current-device'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/es/integration/react'
// import { BrowserRouter } from 'react-router-dom'
// import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { setRedirectToApp } from './action/redirect-to-app-actions'
import { persistStore } from 'redux-persist'
import RedirectToApp from './component/redirect-to-app'

import { store } from './lib/store'
import ReactGA from 'react-ga'
import { merchantTypes } from './lib/merchantUtils';
import isNil from 'lodash/isNil'
import { BrowserRouter, Routes, Route } from 'react-router-dom';

let persistor = persistStore(store)

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      passwordReset: false
    }
  }

  componentDidMount() {
    console.log('------------------------------main root--------------------------------')
    let regex = /\bpassword-reset\b/
    let regexSub = /\btype=\b/
    let url = window.location.href
    if (regex.test(url) || regexSub.test(url) || /\bredeem\b/.test(url)) {
      this.setState({ passwordReset: true })
    }

    ReactGA.initialize('UA-107140559-3', {
      debug: true,
      titleCase: false
    })

    ReactGA.pageview(window.location.pathname + window.location.search)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.selectedSubscription !== nextProps.selectedSubscription) {
      this.setState({ subscriptionPlan: nextProps.selectedSubscription })
    }
    if (!nextProps.redirectToApp || !store.getState().redirectToApp) {
      store.dispatch(setRedirectToApp(this.setRedirect))
    }
  }

  setRedirect = () => {
    if (store.getState().auth && store.getState().auth.token) {
      store.getState().logoutFunction()
    }
    this.setState({ passwordReset: false })
  }

  render() {
    const muiTheme = createTheme({
      overrides: {
        MuiSelect: {
          icon: {
            color: '#959595'
          }
        }
      },
      palette: {
        primary: {
          main: 'rgba(255, 255, 255)'
        },
        secondary: {
          main: 'rgba(88, 149, 0)'
        },
        background: {
          paper: '#1d1d1d'
        },
        action: {
          selected: 'rgba(0,0,0,0.8)',
          hover: 'rgba(0,0,0,0.4)'
        }
      }
    })

    const BasemapSite = (
      <PersistGate persistor={persistor}>
        <ThemeProvider theme={muiTheme}>
          <BrowserRouter>
            {window.google && <App />}
          </BrowserRouter>
        </ThemeProvider>
      </PersistGate>
    )

    const marketing = !isNil(merchantTypes[window.location.pathname.split('/')[1]])

    return (
      <Provider store={store}>
        {device.type == 'mobile'
          && !this.state.passwordReset
          && window.location.pathname.substring(1) !== 'claim'
          && window.location.pathname.substring(1) !== 'EastmansProTrial'
          && !marketing ? <RedirectToApp /> : BasemapSite}
      </Provider>
    )
  }
}

// ReactDom.render(<Main />, document.getElementById('root'))
window.deferReactApp.then(() => {
  ReactDOM.render(<Main />, document.getElementById('root'));
});
